import { render, staticRenderFns } from "./OurFavouriteButton.vue?vue&type=template&id=e0ff869e&"
import script from "./OurFavouriteButton.vue?vue&type=script&lang=js&"
export * from "./OurFavouriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports